import { useRouter } from 'next/router';
import type { ParsedUrlQuery } from 'querystring';
import { useCurrentRefinements } from 'react-instantsearch';
import { useLocaleContext } from '../context';
import { createFacetAttributeNames } from '../utils/algoliaFilterUtils';

export function useAlgoliaAppliedFilter() {
  const { items: currentRefinements } = useCurrentRefinements({
    excludedAttributes: ['price.centAmount', 'query'],
  });
  const router = useRouter();
  const { locale } = useLocaleContext();

  const clearAll = () => {
    const newQuery: ParsedUrlQuery = {};

    const refinementList = createFacetAttributeNames(locale).concat(['minPrice', 'maxPrice']);
    Object.entries(router.query || {})
      .filter(([key]) => {
        const newKey = key.split('[')[0];
        return !refinementList.includes(newKey);
      })
      .forEach(([key, value]) => {
        newQuery[key] = value;
      });

    const pathname = Object.keys(newQuery).length > 0 ? router.pathname : router.asPath.split('?')[0];

    router.push(
      {
        pathname,
        query: newQuery,
      },
      undefined,
      {
        shallow: true,
      },
    );
  };
  return {
    currentRefinements,
    clearAll,
  };
}
